import { FRAC_LAYER, RIG_LAYER } from "constants/mapLayers.constants";
import mapboxgl from "mapbox-gl";

type MapLayerQueries = Pick<mapboxgl.Map, "getLayer" | "queryRenderedFeatures">;

/**
 * Whether any rig or frac crew features are currently rendered in the viewport.
 * Only queries layers that exist on the style — querying a missing layer id
 * makes Mapbox throw — and hidden layers render nothing, so unchecked layers
 * report false without special-casing.
 */
export function hasRenderedRigFracFeatures(mapbox: MapLayerQueries): boolean {
  const rigFracLayers = [RIG_LAYER, FRAC_LAYER].filter((layerId) =>
    mapbox.getLayer(layerId)
  );
  if (!rigFracLayers.length) {
    return false;
  }
  return mapbox.queryRenderedFeatures(undefined, { layers: rigFracLayers }).length > 0;
}
